<template>
  <validation-provider v-slot="{errors}"
                       :vid="$attrs.vid"
                       :name="$attrs.vname"
                       :mode="mode"
                       :rules="rules"
                       :bails="bails"
                       class="menu-has-id"
                       :id="$attrs.vid">
    <component :is="isWhat(sTag)"
               v-model="innerValue"
               :error-messages="resolveErrorMessagesHidden(errors)"
               :error="errors.length > 0"
               :id="$attrs.vid"
               v-bind="$attrs"
               :attach="`#${$attrs.vid}`"
               no-data-text=""
               hide-no-data
               outline
               :menu-props="sTag === 'select' ? { closeOnContentClick: true, auto: true } : 'auto'"
               v-on="$listeners">
      <v-list-tile v-if="sTag === 'select'"
                   slot="prepend-item"
                   @click="emptySelectedHandler">
        <v-list-tile-title>請選擇</v-list-tile-title>
      </v-list-tile>
    </component>

    <!-- <v-autocomplete v-model="innerValue"
                    :error-messages="resolveErrorMessagesHidden(errors)"
                    :error="errors.length > 0"
                    :id="$attrs.vid"
                    v-bind="$attrs"
                    :attach="`#${$attrs.vid}`"
                    class="menu-has-id"
                    menu-props="auto"
                    v-on="$listeners"></v-autocomplete> -->

  </validation-provider>
</template>
<script>
import BaseInputValidate from './BaseInputValidate'
export default {

  name: 'b-select',

  extends: BaseInputValidate,

  methods: {
    emptySelectedHandler () {
      this.innerValue = null
      this.defChangeHandler()
    }
  }
}
</script>
<style>
</style>
